import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import logo from "../static/logos/logo.PNG";
import fb from "../static/facebook.svg";
import tw from "../static/twiter.svg";
import lin from "../static/linkedin.svg";
import Apple from '../static/appleStore.svg'
import Google from '../static/googleStore.svg'
import Youtube from '../static/youtube.svg'
import Insta from '../static/insta.svg'

import ph from "../static/ph.svg";
import ad from "../static/ad.svg";
import em from "../static/em.svg";
import { Link } from "react-router-dom";
import { useState } from "react";
import { getLocalData } from "../utils/localStorage";
import { useSelector } from "react-redux";
import { getContactInformationRedux } from "../redux/pharmacySlice";
import { useDispatch } from "react-redux";

function Footer() {
  const [loggedIn, setLoggedIn] = useState(false);

  //currency=
  const address = useSelector(
    (state) => state.pharmacy.contactInfo.data.address
  );
  const email = useSelector(
    (state) => state.pharmacy.contactInfo.data.supportEmail
  );
  const phoneNumber = useSelector(
    (state) => state.pharmacy.contactInfo.data.supportPhoneNumber
  );
  const facebook = useSelector(
    (state) => state.pharmacy.contactInfo.data.facebook
  );
  const twitter = useSelector(
    (state) => state.pharmacy.contactInfo.data.twitter
  );
  const instagram = useSelector(
    (state) => state.pharmacy.contactInfo.data.instagram
  );
  const youtube = useSelector(
    (state) => state.pharmacy.contactInfo.data.youtube
  );


  const pharmacyName = useSelector((state) => state.pharmacy.pharmacyDetails.pharmacy.pharmacyName);


 
  

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getContactInformationRedux());
  }, []);

  useEffect(() => {
    if (getLocalData("user-info")?.userToken?.length > 0) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [getLocalData("user-info")?.userToken]);

  return (
    <footer className="">
      <div className="container img-footer-cont"></div>

      <div className="container container-main">
        <div className="sec F-sec-1 aboutus">
          <Link to="/">
            <img src={logo} className="log-main" alt="footer" />
          </Link>

          <ul className="sociallinks d-md-flex d-none">
            {facebook && (
              <li>
                <a href={facebook}>
                  <img src={fb} alt="footer" />
                </a>
              </li>
            )}
            {instagram && (
              <li>
                <a href={instagram}>
                  <img src={Insta} alt="footer" />
                </a>
              </li>
            )}
            {twitter && (
              <li>
                <a href={twitter}>
                  <img src={tw} alt="footer" />
                </a>
              </li>
            )}

            {youtube && (
              <li>
                <a href={youtube}>
                  <img src={Youtube} alt="footer" />
                </a>
              </li>
            )}
          </ul>
          <Row className='d-md-none d-block my-5'>
          <Col  md={12} className='app-button-center '>
          {
            process.env.REACT_APP_DEFAULT_APPLESTOER_LINK !== '#' && (
              <a href={`${process.env.REACT_APP_DEFAULT_APPLESTOER_LINK}`} target="_blank" className='app-btton d-flex'> 
              <img src={Apple} alt="apple"/> 
              <div className='app-buttons-inner'>
                <span className='top-text'>Download on the</span>
                <span className='bottom-text'>App Store</span>
              </div>

              </a> 
            )
          }{
            process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK !== '#' && (
              <a href={`${process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK}`} target="_blank" className='app-btton d-flex'>
              <img src={Google} alt="google"/> 
                <div className='app-buttons-inner'>
                <span className='top-text'>Get it on</span>
                  <span className='bottom-text'>Google Play</span>
                </div>
                 </a>
            )
          }
                </Col>
          </Row>
        </div>
        <div className="sec F-sec-2 aboutus  ">
          <h3 className="header-3-footer">Quick Links</h3>
          <ul className="qlinks">
            <li>
              <Link className="footer-text" to="/brands">
                Brands
              </Link>
            </li>
            <li>
              <Link className="footer-text" to="/categories">
                Categories
              </Link>
            </li>
            <li>
              <Link className="footer-text" to="/allofferrproducts">
                Offers
              </Link>
            </li>
            <li>
              <Link className="footer-text" to="/featuredproducts">
                Featured Products
              </Link>
              {/* {loggedIn ? (
                <Link to="/user" className="footer-text" href="/">
                  My Account
                </Link>
              ) : (
                <Link to="/login" className="footer-text" href="/">
                  Login / Sign Up
                </Link>
              )} */}
            </li>
          </ul>
        </div>
        <div className="sec F-sec-3 aboutus">
          <h3 className="header-3-footer">Legal</h3>
          <ul className="qlinks">
            <li>
              <Link to="/termsconditions" className="footer-text" href="/">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacypolicy" className="footer-text" href="/">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
        <div className="sec F-sec-4 aboutus">
          <h3 className="header-3-footer">Reach us</h3>
          <ul className="qlinks">
            <li>
              {phoneNumber && (
                <Row className="footer-text">
                  <Col xs={2} md={2}><img src={ph} alt="ph" /></Col>
                  <Col xs={10} md={10}> {phoneNumber}</Col>
                </Row>
              )}
            </li>
            <li>
              {email && (
                <Row className="footer-text">
                  <Col xs={2} md={2}><img src={em} alt="em" /></Col>
                  <Col xs={10} md={10}>{email}</Col>
                </Row>
              )}
            </li>
            <li>
              {address && (
                <Row className="footer-text">
                  <Col xs={2} md={2}><img src={ad} alt="ad" /></Col>
                  <Col xs={10} md={10} className="add-ftr">{address}</Col>
                </Row>
              )}
            </li>
            <li>
              <Row>
              <Col  md={12} className='app-button-center d-md-flex d-none px-0'>
              {
                process.env.REACT_APP_DEFAULT_APPLESTOER_LINK !== '#' && (
                  <a href={`${process.env.REACT_APP_DEFAULT_APPLESTOER_LINK}`} target="_blank" className='app-btton d-flex'> 
                  <img src={Apple} alt="apple"/> 
                  <div className='app-buttons-inner'>
                    <span className='top-text'>Download on the</span>
                    <span className='bottom-text'>App Store</span>
                  </div>

                  </a> 
                )
              }{
                process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK !== '#' && (
                  <a href={`${process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK}`} target="_blank" className='app-btton d-flex'>
                  <img src={Google} alt="google"/> 
                    <div className='app-buttons-inner'>
                    <span className='top-text'>Get it on</span>
                      <span className='bottom-text'>Google Play</span>
                    </div>
                     </a>
                )
              }
                </Col>
              </Row>
            </li>
          </ul>
        </div>
        {/* <div className="sec F-sec-5 aboutus">
          <br />
          <ul className="qlinks">
            <li>
              <a className="footer-text" href="/">
                Careers
              </a>
            </li>
            <li>
              <Link to="/termsconditions" className="footer-text" href="/">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacypolicy" className="footer-text" href="/">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>   {/* <div className="sec F-sec-5 aboutus">
          <br />
          <ul className="qlinks">
            <li>
              <a className="footer-text" href="/">
                Careers
              </a>
            </li>
            <li>
              <Link to="/termsconditions" className="footer-text" href="/">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacypolicy" className="footer-text" href="/">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div> */}
      </div>

      <div className="container">
        <Row>
      

          
          <Col xs={12} className=" d-md-none d-block sl-ftr">
          <ul className="sociallinks ">
            {facebook && (
              <li>
                <a href={facebook}>
                  <img src={fb} alt="footer" />
                </a>
              </li>
            )}
            {instagram && (
              <li>
                <a href={instagram}>
                  <img src={Insta} alt="footer" />
                </a>
              </li>
            )}
            {twitter && (
              <li>
                <a href={twitter}>
                  <img src={tw} alt="footer" />
                </a>
              </li>
            )}

            {youtube && (
              <li>
                <a href={youtube}>
                  <img src={Youtube} alt="footer" />
                </a>
              </li>
            )}
          </ul>
          </Col>
          <Col lg={12} className="copyright footer-text text-center">
            © {pharmacyName && ( pharmacyName)} 2022. All Rights Reserved.
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
